import { APIURL } from "../models/api-base";
import { apiUrl_links } from "../models/api-urls";
import fetchService from "../modules/APIService";

class Service extends fetchService {
    constructor() {
        super(APIURL);
    }

    getAllLinks = async () => {
        const response = await this.get(apiUrl_links);
        return response;
    };

    createLink = async (data) => {
        const response = await this.post(apiUrl_links, data);
        return response;
    };

    updateLink = async (id, data) => {
        const response = await this.patch(`${apiUrl_links}/${id}`, data);
        return response;
    };

    toggleLinkStatus = async (id) => {
        const response = await this.patch(`${apiUrl_links}/${id}/status`);
        return response;
    };

    archiveLink = async (id) => {
        const response = await this.patch(`${apiUrl_links}/${id}/archive`);
        return response;
    };

    createSubLink = async (linkId, data) => {
        const response = await this.post(`${apiUrl_links}/${linkId}/sublinks`, data);
        return response;
    };

    updateSubLink = async (linkId, subLinkId, data) => {
        const response = await this.patch(`${apiUrl_links}/${linkId}/sublinks/${subLinkId}`, data);
        return response;
    };

    toggleSubLinkStatus = async (linkId, subLinkId) => {
        const response = await this.patch(`${apiUrl_links}/${linkId}/sublinks/${subLinkId}/status`);
        return response;
    };

    archiveSubLink = async (linkId, subLinkId) => {
        const response = await this.patch(`${apiUrl_links}/${linkId}/sublinks/${subLinkId}/archive`);
        return response;
    };

    reorderLink = async (id, order) => {
        const response = await this.patch(`${apiUrl_links}/${id}`, { order });
        return response;
    };

    reorderSubLink = async (linkId, subLinkId, order) => {
        const response = await this.patch(`${apiUrl_links}/${linkId}/sublinks/${subLinkId}`, { order });
        return response;
    };
}

const LinksService = new Service();
export default LinksService;
